import UPEmptyState from './UPEmptyState';

export default UPEmptyState;
